import $ from 'jquery'
import {getTicket,setTicket} from '../../utils/Session'
var BASE_URL='http://sample.bingo08.com:6040/sample';
var SUCCESS_CODE = "success";
var RESPONSE_CODE_NOTLOGIN = "login.user.not.login";
function isStringEmpty(toCheck) {
    if (toCheck == null || toCheck == undefined || toCheck === '' || 'null' == toCheck) {
        return true;
    }
    return false;
}

export const doHttpAjax=(uri, method, data, successCallback, errorCallback) =>{
    var ticket = getTicket();
    setTicket(ticket);
    var requestData = JSON.stringify(data);
    if (isStringEmpty(data)) {
        requestData = data;
    }
    $.ajax({
        url: BASE_URL + uri,
        type: method,
        data: requestData,
        headers: {
            'Content-Type': 'application/json',
            'ticket': ticket
        },
        success: successCallback,
        error: errorCallback,
        complete: function (data) {
            if (RESPONSE_CODE_NOTLOGIN == data.responseJSON.code) {
                // quitLogin();
                return;
            }
            if (SUCCESS_CODE != data.responseJSON.code) {
                alert(data.responseJSON.message);
            }
        }
    })
}
export default{
    doHttpAjax,
}



// WEBPACK FOOTER //
// ./src/components/DoAjax/doAjax.js